const InjectTokens = {
  eventSaveUserType: 'userType',
  meetingTypesMock: 'meetingTypesMock',
}

export default InjectTokens
